module.exports = __webpack_public_path__ + "static/media/instalaciones2.ff5b72e8.webp";